export enum SessionStorageKeys {
    USER = 'user',
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken',
    SESSION_DATA = 'sessionData',
}

export const useSessionStorage = () => {
    const getItem = (key: string): string | null => {
        return sessionStorage.getItem(key)
    }

    const setItem = (key: string, value: unknown): void => {
        sessionStorage.setItem(key, JSON.stringify(value))
    }

    const getParsedItem = <T = unknown>(key: string): T | undefined => {
        const itemString = getItem(key)
        if (itemString) return JSON.parse(itemString) as T
        return undefined
    }

    const removeItem = (key: string): void => {
        sessionStorage.removeItem(key)
    }

    const clear = (): void => {
        sessionStorage.clear()
    }

    return {
        getItem,
        setItem,
        getParsedItem,
        removeItem,
        clear,
    }
}
